<div class="auto">
  <div class="auth-wrapper legal_mobile">
  <div class="card service_agreement">
    <div class="text-center">
      <img src="assets/img/master_service.png" alt="">
    </div>
    <div class="header text-center">
      <!-- <div class="icon">📄</div> -->
      <div class="text-center w-100">
        <h2>Master Service Agreement</h2>
        <p>Please review and accept the terms to proceed</p>
      </div>
    </div>

    <!-- Agreement Box -->
    <!-- <div class="agreement-box" #agreementBox (scroll)="onScroll()">
      <h4>Event Platform Service Agreement</h4>

      <p>
        This Service Agreement ("Agreement") is entered into between Event
        Platform ("Platform") and Event Masters Pvt Ltd ("Organizer").
      </p>

      <h5>1. Services Provided</h5>
      <p>
        The Platform agrees to provide event ticketing, management, analytics,
        and payment processing services. This includes online ticket sales,
        attendee management, reporting tools, and support services.
      </p>

      <h5>2. Fee Structure</h5>
      <ul>
        <li>Convenience Fee: 2.5% per ticket transaction</li>
        <li>Listing Fee for Free Events: ₹500 per event</li>
        <li>Payment gateway charges as applicable</li>
      </ul>

      <h5>3. Organizer Responsibilities</h5>
      <p>
        The Organizer agrees to provide accurate event information, comply with
        all applicable laws, and ensure proper execution of events.
      </p>

      <h5>4. Term & Termination</h5>
      <p>
        This Agreement remains in effect unless terminated by either party with
        prior written notice of 30 days.
      </p>

      <h5>5. Liability</h5>
      <p>
        The Platform shall not be liable for any indirect or consequential
        damages arising from the use of services.
      </p>

      <h5>6. Governing Law</h5>
      <p>
        This Agreement shall be governed and construed in accordance with the
        laws of India.
      </p>

      <p *ngFor="let i of [].constructor(8)">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec
        odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.
      </p>
    </div> -->



    <div class="container mt-3">

      <div class="card mt-0 shadow-sm rounded-4 p-4" >
        <div class="d-flex justify-content-between align-items-center master_service">

          <div class="d-flex align-items-center master_service">
            <div class="master_icons">
              <div class="file-icon me-3">
                <img src="assets/img/agreement_icon.png" alt="">
              </div>
            </div>

            <div>
              <h5 class="mb-1 fw-semibold">Master Service Agreement</h5>
              <small class="text-muted">Pre-filled with your details</small>
            </div>
          </div>



          <a class="btn btn-primary px-4" target="_blank" [href]="cleanUrl" download="agreement.pdf"
            (click)="clikedDown()">Download</a>

        </div>
      </div>

      <!-- Success Alert -->
      <div *ngIf="downloadbutton" class="alert alert-success d-flex align-items-center mt-3 rounded-3 fs-18"
        role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-check2"
          viewBox="0 0 16 16">
          <path
            d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
        </svg>
        <span class="fs-18"> Agreement downloaded successfully</span>
      </div>

      <!-- Instructions Box -->
      <div class="card mt-4 p-4 rounded-4 instruction-box">
        <p class="mb-0 text-primary">
          <strong>Instructions:</strong>
          Download the agreement, sign it (digitally or physically),
          and upload the signed copy below.
          Accepted formats: PDF, JPG, PNG (max 10MB)
        </p>
      </div>
      <div class="checkbox">
        <input type="checkbox" [disabled]="cleanUrl==''" [(ngModel)]="isChecked" id="agree" />
        <label for="agree">
          I have read and agree to the terms and conditions of this Service
          Agreement. I confirm that I am an authorized signatory.
        </label>
      </div>

      <div class="form-group mt-3">
        <label class="mb-2">Upload Signed Agreement <span class="required">*</span></label>
        <input type="file" id="panFile" (change)="onFileSelect($event)" hidden />
        <div class="file-box">
          <span class="file-name">
            <!-- {{ selectedFileName || 'Choose file...' }} -->

            {{
            selectedFileName
            ? (
            selectedFileName.length > 20
            ? (selectedFileName.slice(0,20) + '' +
            selectedFileName.slice(selectedFileName.lastIndexOf('.')))
            : selectedFileName
            )
            : 'Choose file...'
            }}
          </span>

          <div class="file-box-actions">
            <button
              *ngIf="agreementSignUrl"
              type="button"
              class="browse-btn"
              (click)="viewAgreementSign()">
              View
            </button>
            <button type="button" class="browse-btn" (click)="triggerFile()">
              {{ agreementSignUrl ? 'Change' : 'Browse' }}
            </button>
          </div>
        </div>
      </div>


    </div>

    <!-- Buttons -->
    <div class="button-row mt-4">
      <button class="secondary-btn" (click)="back()">
        Back
      </button>

      <button class="primary-btn " [disabled]="!selectedFileName || !isChecked" (click)="submit()">
        Accept & Continue
      </button>
    </div>
  </div>

  <div  class="step-dots"><span  class="dot"></span><span  class="dot"></span><span  class="dot active"></span><span  class="dot"></span><span  class="dot"></span><span  class="dot"></span><span  class="dot"></span><span  class="dot"></span></div>
</div>

<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>
</div>